<app-modal-base
  [title]="'API.apiKey' | translate"
  [showSecondaryButton]="false"
  [showPrimaryButton]="false"
  (close)="dialogRef.close(false)"
>
  <div class="p-3 border-2 border-#ECECEC rounded-xl flex flex-wrap gap-3 bg-white">
    <!-- card header -->
    <div class="flex flex-nowrap w-full items-center gap-2">
      <i class="ph ph-key"></i>
      <h3 class="font-bold">{{ 'integrator' | translate }}</h3>
    </div>

    <!-- card status -->
    <div
      class="bg-[#EFF0F4] border border-[#E8E8E8] rounded-xl w-full p-2 flex justify-between items-center"
      (click)="clipboardService.copyToClipboard(data, 'Successfully copied the Api key to the clipboard')"
    >
      <span class="max-w-[80%]">{{ data }}</span>
      <i class="ph ph-copy text-[#4F596B] text-xl"></i>
    </div>

    <div class="block items-center w-full text-red-700 rounded-lg">
      {{ 'API.thisIsTheOnlyTimeNickyWillDisplay' | translate }}
    </div>
  </div>
</app-modal-base>
